import TableTab from "../tableTab/TableTab";

const dynamicTablePlugin = {
  Renderer: ({ data, children }) => <TableTab data={data}>{children}</TableTab>,
  id: "dynamicTablePlugin",
  title: "Dynamic Tab Table",
  description: "Dynamic Tab Table",
  version: "dynamicTablePlugin",
};

export default dynamicTablePlugin;
